exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nnm-datatable .col-sm-12 {\n\tpadding-left: 0;\n\tpadding-right: 0;\n}\n\nnm-datatable .table > thead > tr > th {\n\tfont-weight: normal;\n}\n\na {\n\tcursor: pointer;\n}\n\n.report-form .form-group label.control-label{\n    margin-left: 20px;\n}\n.report-form .form-group .col-checkbox .checkbox{\n    position: absolute;\n    top: 0;\n    left: 2px;\n    margin: 0;\n}\n\n.form-group select{\n    max-height: 30px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/styles.css
// module id = 429
// module chunks = 3